import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

export async function deleteServiceRequest(id: string) {
  const response = await fetcher(
    `${API_BASE_PATH}/${id}`,
    {
      method: 'DELETE',
    },
    undefined
  );

  return response;
}
